<template>
  <div class="bg-grey-extralight font-semibold text-grey-darker mx-4 my-3 text-sm rounded py-3">
    <div class="px-4 pb-3 mb-1 border-b" style="border-color: #e6e8ef">
      <div>{{healthParameter.type}} <span class="text-xs text-grey font-normal">(Updated on: <span class="text-grey-darker">{{hraDate}}</span>)</span></div>
    </div>
    <div class="px-4">
      <div v-if="healthParameter.type === 'FAMILY HISTORY'" class="border border-grey-lightest mt-2">
        <div class="flex flex-row items-center justify-between bg-white px-3 mb-3">
          <p class="py-3">Medical Problem</p>
          <div class="flex flex-row items-center justify-evenly" style="min-width: 170px">
            <div class="flex flex-row items-center pl-3 py-3 border-l" style="width: 89px"><img class="w-4 mr-1" src="../../assets/mother.svg" /><p>Mother</p></div>
            <div class="flex flex-row items-center pl-3 py-3 border-l" style="width: 85px"><img class="w-4 mr-1" src="../../assets/father.svg" /><p>Father</p></div>
          </div>
        </div>
        <div v-for="item in healthParameter.items" :key="item.name" class="flex flex-row items-center justify-between px-3">
          <p class="pb-3">{{item.name}}</p>
          <div class="flex flex-row items-center justify-evenly" style="min-width: 170px">
            <div class="flex flex-row items-center pl-3 pb-3 border-l" style="width: 89px"><p class="mx-auto" :class="item.mother.color">{{item.mother.text}}</p></div>
            <div class="flex flex-row items-center pl-3 pb-3 border-l" style="width: 85px"><p class="mx-auto" :class="item.father.color">{{item.father.text}}</p></div>
          </div>
        </div>
      </div>
      <div v-else v-for="item in healthParameter.items" :key="item.name" class="flex flex-row justify-between pt-2">
        <div class="capitalize">{{item.name}}</div>
        <div :class="item.color">{{item.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    healthParameter: Object,
    hraDate: String
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Customer/PatientHra.vue